import { render, staticRenderFns } from "./WfSelector.vue?vue&type=template&id=41fd9678&scoped=true"
import script from "./WfSelector.vue?vue&type=script&lang=js"
export * from "./WfSelector.vue?vue&type=script&lang=js"
import style0 from "./WfSelector.vue?vue&type=style&index=0&id=41fd9678&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41fd9678",
  null
  
)

export default component.exports